/**
 * Component: Collection Panel
 * ------------------------------------------------------------------------------
 * The control panel on the Model Collection Landing template.
 *
 * @namespace CollectionPanel
 */
import log from 'salvo-lite/log'
import cssClasses from '../helpers/cssClasses'
import { on } from '../helpers/utils'
import OverlayScrollBar from 'overlayscrollbars'
import zenscroll from 'zenscroll'
import breakpoints from '../helpers/breakpoints'

class CollectionPanel {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            ...JSON.parse(elem.getAttribute('data-carousel') || '{}')
        }

        this._scrollBars = null

        this._selectors = {
            letters: '.model-collection-landing__panel-letter'
        }

        this._nodeSelectors = {
            letters: elem.querySelectorAll(this._selectors.letters)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise carousel component.
     */
    onInit () {
        this._addListeners()
        this._handleResize()
    }

    _addListeners () {
        this._nodeSelectors.letters.forEach((letter) => {
            on('click', letter, (e) => this._handleLetterClick(e))
        })

        on('resize', window, (e) => this._handleResize(e))
    }

    _handleResize (e) {
        if (window.innerWidth <= 768) {
            this._scrollBars = OverlayScrollBar(this._elem, {})
        } else {
            if (this._scrollBars !== null) {
                this._scrollBars.destroy()
            }
        }
    }

    _handleLetterClick (e) {
        e.preventDefault()
        let offset = 0
        this._elem.querySelector(`${this._selectors.letters}.${cssClasses.active}`).classList.remove(cssClasses.active)
        e.target.classList.add(cssClasses.active)

        const letter = e.target.getAttribute('data-letter')
        // const block = document.querySelector(`#block-${letter}`).getBoundingClientRect().top

        if (window.innerWidth < breakpoints.medium) {
            offset = -100
        }

        zenscroll.center(document.querySelector(`#block-${letter}`), 999, offset)
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //   init,
    // })
}

export default CollectionPanel



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CollectionPanel.js